// extracted by mini-css-extract-plugin
module.exports = {"title":"GeneralPageHeader_title__m545J","description":"GeneralPageHeader_description__uK54T"};